$(function(){
  $('.card-detect-form-change form').each(function(){
    let $form = $(this)
    let $card = $form.closest('.card')
    let $header = $card.find('.card-header')
    let original_form = $form.serialize()
    $form.find(':input').on('change input', function(){
      let changed = $form.serialize() !== original_form
      $card.toggleClass('border-primary', changed)
      $header.toggleClass('bg-primary text-white', changed)
      $card.find('.unsaved-changes').toggleClass('invisible', ! changed)
    });
  });
});


// Input changes detect function
// Detects changes in form inputs with the class 'detect-form-change'
$(function(){
  $('.detect-form-change form').each(function() {
    let form = $(this);
    let inputs = form.find(':input');
    let changed = false;

    inputs.each(function(){
      let i = $(this);
      if (i.prop("type") == "checkbox") {
        // Save current value of element
        i.data('oldVal', i.prop("checked"));

        // Look for changes in the value by several methods
        i.on("propertychange click change", function () {
          changed = i.prop("checked") != !!i.data('oldVal');
          i.parent().toggleClass('input-changed', changed);
        });
      } else if (i.prop("type") == "radio") {
        let originalRadio;
        let siblingRadios = i.parent().siblings('.form-check').children(':input');
        if (i.prop("checked")){
          originalRadio = i;
        } else {
          siblingRadios.each(function () {
            if($(this).prop("checked")) {
              originalRadio = $(this);
            }
          });
        }

        // Save current value of element
        i.data('oldVal', i.prop("checked"));

        // Look for changes in the value by several methods
        i.on("propertychange change",function () {
          changed = i.prop("checked") != !!i.data('oldVal');

          // Manually make all sibling radios to look unchanged (cant detect deselects)
          siblingRadios.each(function () {
            $(this).parent().toggleClass('input-changed', false);
          });

          if(originalRadio != null){
            if(i == originalRadio){
              i.parent().toggleClass('input-changed', changed);
            } else {
              i.parent().toggleClass('input-changed', changed);
              originalRadio.parent().toggleClass('input-changed', changed);
            }
          } else {
            i.parent().toggleClass('input-changed', changed);
          }
        });

      } else {
        // Save current value of element
        i.data('oldVal', i.val());

        // Look for changes in the value by several methods
        i.on("propertychange input paste", function(){
          changed = i.data('oldVal') != i.val();
          i.toggleClass('input-changed', changed);

        });
      }
    });
  });
});